<template>
  <v-app>
    <div class="contenedor-superior">
      <div class="forma01"></div>
      <div class="forma02"></div>
      <div class="card01">
        <div
          style="
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
          "
        >
          <div class="contenedor-logo">
            <img
              src="img/tomolab-logo.png"
              style="width: 309px; height: 80px"
            />
          </div>
          <!-- <label for="" class="login-title-text">Iniciar Sesion</label> -->
          <div
            class="login-subtitle animated fadeInDown slow"
            style="padding-top: 10px"
          >
            <span>Selecciona una sucursal!</span>
          </div>
          <template>
            <div style="">
              <v-row class="animated fadeInDown slow">
                <v-col cols="12">
                  <v-autocomplete
                    v-model="value_office"
                    :items="offices"
                    hide-details
                    label="Sucursal"
                    outlined
                    :item-text="customText"
                    item-value="id"
                    color="rgba(100, 100, 100, 0.5)"
                    class="autoSelect"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </div>
            <div>
              <v-row>
                <v-col cols="12">
                  <button
                    @click="handleSelectOffice"
                    class="login-button-custom animated fadeInUp slower"
                  >
                    ACCEDER
                  </button>
                </v-col>
              </v-row>
            </div>
          </template>
        </div>
      </div>

      <div class="card02">
        <div
          style="
            display: flex;
            width: 100%;
            height: 100%;
            justify-content: center;
            align-items: center;
            flex-direction: column;
          "
        >
          <div class="login-title animated fadeInDown slow">
            <label
              for=""
              class="login-title-text"
              style="color: white; font-size: 2.2rem !important"
              >Bienvenido</label
            >
          </div>
          <div class="login-title animated fadeInDown slow">
            <span
              class="login-title-text"
              style="color: white; font-size: 2.2rem !important"
            >
              {{ current_employee.fullname }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <v-snackbar
      v-model="show_message_login"
      color="error"
      :timeout="3000"
      :top="'top'"
    >
      Debe seleccionar una sucursal
      <v-btn dark text @click="show_message_login = false"> Cerrar </v-btn>
    </v-snackbar>
  </v-app>

  <!-- <v-app>
    <div class="contenedor">
      <div class="bloque01">
        <div style="width: 100%; height: 100%; position: relative">
          <img src="/img/Blood_test-cuate.png" class="class-logo" alt="logo" />

          <div style="height: 100%; width: 90%; overflow: hidden">
            <svg
              viewBox="0 0 500 150"
              preserveAspectRatio="none"
              style="height: 100%; width: 100%"
            >
              <path
                d="M-24.60,-41.94 C61.17,153.45 395.26,41.94 526.75,171.21 L500.00,150.00 L0.00,150.00 Z"
                style="stroke: none; fill: rgb(48 181 212)"
              ></path>
            </svg>
          </div>
        </div>
      </div>

      <div class="bloque02">
        <div class="contenedor-logo">
          <img src="img/tomolab-logo.png" style="width: 309px; height: 80px" />
        </div>
        <span class="login-title-text"
          >Hola {{ current_employee.fullname }}</span
        >

        <div class="login-subtitle animated fadeInDown slow">
          <span>Selecciona una sucursal!</span>
        </div>
        <div class="login-form">
          <template>
            <v-row class="animated fadeInDown slow">
              <v-col cols="12">
                <v-autocomplete
                  v-model="value_office"
                  :items="offices"
                  hide-details
                  label="Sucursal"
                  outlined
                  :item-text="customText"
                  item-value="id"
                  color="rgba(100, 100, 100, 0.5)"
                  class="autoSelect"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <button
                  @click="handleSelectOffice"
                  class="login-button animated fadeInUp slower"
                >
                  ACCEDER
                </button>
              </v-col>
            </v-row>

          </template>
        </div>
      </div>
    </div>

    <v-snackbar
      v-model="show_message_login"
      color="error"
      :timeout="3000"
      :top="'top'"
    >
      Debe seleccionar una sucursal
      <v-btn dark text @click="show_message_login = false"> Cerrar </v-btn>
    </v-snackbar>
  </v-app> -->

  <!-- <v-app>
    <div class="login-content color-change">
      <div class="login-container">
        <div class="login-logo animated fadeInDown slow">
          <img src="img/logo-store-3.png" width="100" />
        </div>
        <div class="login-title animated fadeInDown slow">
          <span class="login-title-text"
            >Bienvenido {{ current_employee.fullname }}</span
          >
        </div>
        <div class="login-subtitle animated fadeInDown slow">
          <span>Selecciona una sucursal!</span>
        </div>
        <div class="login-form">
          <template>
            <v-row class="animated fadeInDown slow" v-if="showCompanies">
              <v-col cols="12">
                <v-autocomplete
                  v-model="value_company"
                  :items="user_companies"
                  label="Empresa"
                  hide-details
                  outlined
                  :item-text="customText"
                  item-value="id"
                  @change="handleSelectCompany"
                  :disabled="disabled_company"
                  clearable
                  background-color="#244167"
                  color="white"
                  dark
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="animated fadeInDown slow">
              <v-col cols="12">
                <v-autocomplete
                  v-model="value_sede"
                  :items="sedes"
                  hide-details
                  label="Sede"
                  outlined
                  :item-text="customText"
                  item-value="id"
                  @change="handleSelectSede"
                  :disabled="disabled_sede"
                  clearable
                  background-color="#244167"
                  color="white"
                  dark
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="animated fadeInDown slow">
              <v-col cols="12">
                <v-autocomplete
                  v-model="value_office"
                  :items="offices"
                  hide-details
                  label="Sucursal"
                  outlined
                  :item-text="customText"
                  item-value="id"
                  background-color="#00039c"
                  color="white"
                  dark
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <button
                  @click="handleSelectOffice"
                  class="login-button animated fadeInUp slower"
                >
                  Ingresar
                </button>
              </v-col>
            </v-row>
          </template>
        </div>
      </div>
      <v-snackbar
        v-model="show_message_login"
        color="error"
        :timeout="3000"
        :top="'top'"
      >
        Debe seleccionar una sucursal
        <v-btn dark text @click="show_message_login = false"> Cerrar </v-btn>
      </v-snackbar>
    </div>
  </v-app> -->
</template>

<script>
import { mapState, mapActions } from "vuex";

import ArrayTools from "../../helpers/ArrayTools";

export default {
  name: "SelectOffice",
  data() {
    return {
      showLogin: true,
      showCompanies: false,
      companies: [],
      value_company: null,
      disabled_company: false,
      sedes: [],
      value_sede: null,
      disabled_sede: false,
      offices: [],
      value_office: null,
      show_message_login: false,
    };
  },
  computed: {
    ...mapState("authentication", [
      "current_employee",
      "token",
      "select_office",
      "user_companies",
      "user_sedes",
      "user_offices",
    ]),
  },
  methods: {
    ...mapActions("authentication", ["set_office_login"]),
    async handleSelectOffice() {
      if (this.value_office !== undefined && this.value_office !== null) {
        await this.set_office_login(this.value_office);
      } else {
        this.show_message_login = true;
      }
    },
    customText(item) {
      let text = item.name;

      return text;
    },
    handleSelectCompany(value) {
      /*
            if(value !== undefined && value !== null){
                this.sedes = ArrayTools.getSedesByCompanyId(this.user_sedes, value)
            } else {
                this.sedes = []
                this.offices = []
            }
            */
      if (value !== undefined && value !== null) {
        this.offices = ArrayTools.getOfficesByCompanyId(
          this.user_offices,
          value
        );
      } else {
        this.offices = [];
      }
    },
    handleSelectSede(value) {
      if (value !== undefined && value !== null) {
        this.offices = ArrayTools.getOfficesBySedeId(this.user_offices, value);
      } else {
        this.offices = [];
      }
    },
    verifyCompany() {
      if (this.user_companies.length == 1) {
        this.value_company = this.user_companies[0].id;
        this.showCompanies = false;
        this.handleSelectCompany(this.value_company);
      } else {
        this.showCompanies = true;
        this.offices = [];
      }
    },
  },
  created() {
    this.verifyCompany();
  },
};
</script>

<style scoped>
html {
  height: 100%;
  background-color: #f4f6f8 !important;
}

body {
  margin: 0px !important;
  height: 100%;
  color: #ffffff;
  font-size: 16px !important;
}

.forma01 {
  width: 13%;
  height: 25%;
  border-radius: 50%;
  position: absolute;
  left: -5%;
  top: -9%;
  /* background-image: radial-gradient(
    circle at 20.12% -14.09%,
    #de56eb 0,
    #c34cee 16.67%,
    #a343f0 33.33%,
    #783cf2 50%,
    #3039f4 66.67%,
    #0038f5 83.33%,
    #003af6 100%
  ); */
  background-image: radial-gradient(
    circle at -14.09% 20.12%,
    #98cd00 0,
    #7bcc00 16.67%,
    #57c900 33.33%,
    #13c600 50%,
    #00c21d 66.67%,
    #00be31 83.33%,
    #00bb42 100%
  );
}

.forma02 {
  width: 13%;
  height: 25%;
  border-radius: 50%;
  position: absolute;
  right: -6%;
  bottom: -11.5%;
  /* background-image: radial-gradient(
    circle at 5.13% 12.35%,
    #653b5e 0,
    #572c59 12.5%,
    #461d55 25%,
    #300d50 37.5%,
    #0c004c 50%,
    #000048 62.5%,
    #000046 75%,
    #000043 87.5%,
    #000041 100%
  ); */
  background-image: radial-gradient(
    circle at 87.65% 94.87%,
    #98cd00 0,
    #7bcc00 16.67%,
    #57c900 33.33%,
    #13c600 50%,
    #00c21d 66.67%,
    #00be31 83.33%,
    #00bb42 100%
  );
}

.contenedor-superior {
  position: relative;
  display: flex;
  widows: 100%;
  height: 100%;
  background-color: #f0f0f0;
  overflow: hidden;
}

.card01 {
  position: absolute;
  border-radius: 10px;
  margin-top: 2.5%;
  background-color: white;
  width: 35%;
  height: 75%;

  z-index: 1;

  top: 0;
  left: 0;
  right: 33%;
  bottom: 0;
  margin: auto;

  box-shadow: 0px 0px 12px 10px rgba(143, 143, 143, 0.25);
}

.card03 {
  background-color: #ff000000;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 24px;
  padding-top: 20px;
  padding-bottom: 21px;
  font-size: 12px !important;
  font-weight: bold !important;
  font-family: sans-serif !important;

  padding-left: 20px;
}

.card02 {
  position: absolute;
  border-radius: 10px;
  background-color: #429a22; /* #0150f5; */
  width: 35%;
  height: 85%;

  top: 0;
  left: 33%;
  right: 0;
  bottom: 0;
  margin: auto;

  background: url("../../../public/img/background_green.jpg");

  box-shadow: 0px 0px 12px 10px rgba(143, 143, 143, 0.25);
}

.path-img {
  background-image: radial-gradient(
    circle at 20.12% -14.09%,
    #de56eb 0,
    #c34cee 16.67%,
    #a343f0 33.33%,
    #783cf2 50%,
    #3039f4 66.67%,
    #0038f5 83.33%,
    #003af6 100%
  );
}

.contenedor {
  display: flex;
  widows: 100%;
  height: 100%;
  font-family: sans-serif !important;
}

.bloque01 {
  width: 65%;
  height: 100%;
}

.bloque02 {
  display: flex;
  width: 35%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

input.login-textfield-custom {
  padding: 15px 20px 15px 30px;
  width: 100%;
  background: #ffffff !important;
  color: black !important;
  outline: none !important;
  margin: 15px 0 15px !important;
  box-shadow: 0px 0px 12px 4px rgba(143, 143, 143, 0.1);
  border-color: #26beba !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 5px;
}

.login-title-text {
  font-size: 1.6rem !important;
  font-weight: 700 !important;
  /* text-transform: uppercase; */
  padding: 30px 0 8px;
}

.class-logo {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 70%;
}

.autoSelect {
  /* border-color: #26beba !important;
  border-style: solid !important;
  border-width: 1px !important; */
  border-radius: 5px;
}

/* Este elemento debe tener "position: relative" */
div#is-relative {
  max-width: 420px;
  position: relative;
}

/* El icono debe ser "position: absolute"
 * Ademas le damos un "display: block" y lo posicionamos */
#icon {
  position: absolute;
  display: block;

  user-select: none;
  cursor: pointer;
}
input.input {
  padding-right: 2.5rem;
}

.login-button-custom {
  width: 100%;

  height: 45px;
  border-radius: 5px;
  border: 1px solid #26beba;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 12px;
  padding-right: 12px;
  display: block;
  margin-top: 20px;
  margin-bottom: 4px;
  color: #ffffff;
  background-color: #429a22; /* #26beba 26beba   03164e*/
  cursor: pointer;
  font-family: sans-serif !important;
  font-size: 1rem;
  font-weight: bold;
  outline: none;
}

.login-content {
  background-color: #000f70 !important;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #ffffff;
  font-family: "Baloo Bhaina 2" !important;
  font-size: 16px !important;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #ffffff;
  font-family: "Baloo Bhaina 2" !important;
}

.login-logo {
  margin-bottom: 15px;
}

.login-title {
  display: block;
  margin-bottom: 15px;
}

.login-subtitle {
  margin-bottom: 15px;
  font-size: 17px;
}

.login-form {
  display: block !important;
  height: 250px !important;
}

.login-textfield {
  height: 40px !important;
  border-radius: 14px !important;
  border: 1px solid #244167 !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  display: block !important;
  margin-top: 20px !important;
  margin-bottom: 4px !important;
  width: 270px !important;
  color: #ffffff !important;
  background-color: #244167 !important;
  outline: none !important;
  font-family: "Baloo Bhaina 2" !important;
  font-size: 0.9rem !important;
}

.login-button {
  height: 45px;
  border-radius: 7px;
  /* border: 1px solid #26beba; */
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 12px;
  padding-right: 12px;
  display: block;
  margin-top: 10px;
  margin-bottom: 4px;
  width: 100%;
  color: white;
  background-color: rgb(48 181 212); /* #429a22;  #26beba; */
  cursor: pointer;
  font-family: "Baloo Bhaina 2";
  font-size: 1rem;
  font-weight: bold;
  outline: none;
}

/* .login-title-text {
  font-size: 2.3rem !important;
  font-weight: 500 !important;
} */

::-webkit-input-placeholder {
  /* Edge */
  color: #ffffff !important;
  font-family: "Baloo Bhaina 2" !important;
  font-size: 0.9rem !important;
}

:-ms-input-placeholder {
  /* Internet Explorer */
  color: #ffffff !important;
  font-family: "Baloo Bhaina 2" !important;
  font-size: 0.9rem !important;
}

::placeholder {
  color: #ffffff !important;
  font-family: "Baloo Bhaina 2" !important;
  font-size: 0.9rem !important;
}

.v-input__slot {
  background-color: #244167 !important;
}
</style>